import React from 'react'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet-async'
import { urlTransform } from 'lib/string/removeSpaceUtils'
import { getPageTypeSlug } from 'lib/offer/destinationProductPageUtils'

interface Props {
  customerPortalURL: string;
  location?: string;
  holidayType?: string;
  productType: string;
  regionCode: string;
}

function Breadcrumbs(props: Props) {
  const { customerPortalURL, location, holidayType, productType, regionCode } = props

  const locationURL = urlTransform(location)
  const holidayTypeURL = urlTransform(holidayType)
  const productTypeURL = urlTransform(productType)

  const itemListElement = [{
    '@type': 'ListItem',
    position: 1,
    item: {
      id: `${customerPortalURL}/${regionCode.toLowerCase()}/${getPageTypeSlug(productType)}`,
      name: productType,
    },
  }]

  if (location) {
    itemListElement.push({
      '@type': 'ListItem',
      position: 2,
      item: {
        id: `${customerPortalURL}/${regionCode.toLowerCase()}/${locationURL}.${productTypeURL}`,
        name: `${location} ${productType}`,
      },
    })
  }

  if (holidayType) {
    if (location) {
      itemListElement.push({
        '@type': 'ListItem',
        position: 3,
        item: {
          id: `${customerPortalURL}/${regionCode.toLowerCase()}/${locationURL}.${holidayTypeURL}.${productTypeURL}`,
          name: `${location} ${holidayType} ${productType}`,
        },
      })
    } else {
      itemListElement.push({
        '@type': 'ListItem',
        position: 2,
        item: {
          id: `${customerPortalURL}/${regionCode.toLowerCase()}/${holidayTypeURL}.${productTypeURL}`,
          name: `${holidayType} ${productType}`,
        },
      })
    }
  }

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement,
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  )
}

function mapStateToProps(state: App.State) {
  return {
    customerPortalURL: state.system.customerPortalURL,
  }
}

export default connect(mapStateToProps)(Breadcrumbs)
